import { render, staticRenderFns } from "./TourDuLichForm.vue?vue&type=template&id=3d387da9"
import script from "./TourDuLichForm.vue?vue&type=script&lang=js"
export * from "./TourDuLichForm.vue?vue&type=script&lang=js"
import style0 from "./TourDuLichForm.vue?vue&type=style&index=0&id=3d387da9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports